import { isMobile } from 'react-device-detect'
import { push } from 'connected-react-router'
import { IChecklist, IFeatureAvailabilityParams } from 'app/domains/routes/Dashboard/OnboardingChecklist/interface'
import { onboardingId } from 'app/domains/common/MicroActivityBlock/MicroActivityBlock'
import { modal } from 'store/entities/modal/actions'
import { store } from 'store'
import { DASHBOARD, PROFILE } from 'app/domains/routes/constants'

const hideModalAtMobile = () => {
  if (isMobile) {
    store.dispatch(modal.hide())
  }
}
let linkTimeout

const hideFocusModal = (todayActionButton: any) => {
  store.dispatch(modal.hide())
  todayActionButton.style.zIndex = 1
  clearTimeout(linkTimeout)
}

export async function scrollToActionButton() {
  await store.dispatch(push(`/${DASHBOARD}`))
  hideModalAtMobile()
  const todayActionButton = document.getElementById(`${onboardingId}`) as any
  if (todayActionButton) {
    todayActionButton.scrollIntoView({ block: 'center', inline: 'center' })
    todayActionButton.style.zIndex = 1000
    store.dispatch(modal.show())
    linkTimeout = setTimeout(() => hideFocusModal(todayActionButton), 4000)
  } else {
    scrollToPreviousMicroActivityCard()
  }
}

export async function scrollToStoryInput() {
  await store.dispatch(push(`/${DASHBOARD}`))
  const storyBlock = document.getElementById('storyBlock') as any
  if (storyBlock) {
    storyBlock.scrollIntoView({ block: 'center', inline: 'center' })
    storyBlock.style.zIndex = 1000
    store.dispatch(modal.show())
    linkTimeout = setTimeout(() => hideFocusModal(storyBlock), 4000)
    hideModalAtMobile()
  } else {
    scrollToPreviousMicroActivityCard()
  }
}

export async function scrollToPreviousMicroActivityCard() {
  await store.dispatch(push(`/${DASHBOARD}`))
  const previousMicroActivityCard = document.getElementById('previousMicroActivityCard') as any
  previousMicroActivityCard.scrollIntoView({ block: 'center', inline: 'center' })
  previousMicroActivityCard.style.zIndex = 1000
  store.dispatch(modal.show())
  linkTimeout = setTimeout(() => hideFocusModal(previousMicroActivityCard), 4000)
  hideModalAtMobile()
}

export const switchToNotificationsTab = async () => {
  await store.dispatch(push(`/${PROFILE}`))
  const event = new CustomEvent('click', { bubbles: true })
  const notificationsTab = document.getElementById(`notificationtype`) as any
  if (notificationsTab) {
    notificationsTab.dispatchEvent(event)
  }
  hideModalAtMobile()
}

export const scrollToUserNotifications = async () => {
  await switchToNotificationsTab()
  const userNotifications = document.getElementById('notificationSetting') as any
  if (userNotifications) {
    userNotifications.scrollIntoView()
  }
}

export interface IGetCheckListAvailabilityParams {
  checklist: IChecklist
  featureAvailabilityParams: IFeatureAvailabilityParams
}

export const getCheckListAvailabilityParams = ({
  checklist,
  featureAvailabilityParams,
}: IGetCheckListAvailabilityParams) => {
  const {
    isFirstActionCompleted,
    isStoryShared,
    isMobileNumberAdded,
    areNotificationSettingsUpdated,
    isQuizCompleted,
  } = checklist
  const { isStoriesEnabled, isSMSEnabled, isSurveyEnabled } = featureAvailabilityParams
  const defaultChecklistLength = 5

  const availableOrgFeatureNumber =
    defaultChecklistLength - Number(!isStoriesEnabled) - Number(!isSMSEnabled) - Number(!isSurveyEnabled)
  const completedNumber =
    Number(isFirstActionCompleted) +
    Number(isStoriesEnabled && isStoryShared) +
    Number(isSMSEnabled && isMobileNumberAdded) +
    Number(areNotificationSettingsUpdated) +
    Number(isSurveyEnabled && isQuizCompleted)

  return { completedNumber, availableOrgFeatureNumber }
}
